'use client';

/**
 * TipCreator Component
 *
 * Shows tip address for users who want to support the rescue mission.
 * Used on the main rescue page and after successful recovery.
 */
import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button, Tooltip } from '@heroui/react';
import { Heart, Copy, Check, Wallet } from 'lucide-react';
import Col from '@/components/Layout/Flex/Col';
import Row from '@/components/Layout/Flex/Row';
import { useIsMobile } from 'hooks/utility/useIsMobile';
const TIP_ADDRESS = '0xAE8b12744d07CcA9718360a3bA8731063B5dd4f4';
interface TipCreatorProps {
  /** Show compact version (for success screen) */
  compact?: boolean;
  /** Additional class names */
  className?: string;
}
export default function TipCreator(t0) {
  const $ = _c(40);
  const {
    compact: t1,
    className: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const isMobile = useIsMobile();
  const [isCopied, setIsCopied] = useState(false);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(TIP_ADDRESS);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } catch (t4) {
        const err = t4;
        console.error("Failed to copy address:", err);
      }
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const handleCopy = t3;
  if (compact) {
    const t4 = `p-4 bg-warning/10 border border-warning/30 rounded-xl ${className}`;
    let t5;
    let t6;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Row className="items-center gap-2"><Heart className="w-5 h-5 text-warning fill-warning" /><span className="font-semibold text-warning">Support the Rescue Mission!</span></Row>;
      t6 = <p className="text-sm text-foreground-500">Recovered some funds? Help us keep helping the community and fighting back against rugs! Tips are not required but very much appreciated!</p>;
      $[1] = t5;
      $[2] = t6;
    } else {
      t5 = $[1];
      t6 = $[2];
    }
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <code className="flex-1 px-3 py-2 bg-content2 rounded-lg text-xs sm:text-sm break-all">{TIP_ADDRESS}</code>;
      $[3] = t7;
    } else {
      t7 = $[3];
    }
    const t8 = isCopied ? "Copied!" : "Copy Address";
    const t9 = isCopied ? "success" : "warning";
    const t10 = isMobile ? true : false;
    let t11;
    if ($[4] !== isCopied || $[5] !== isMobile) {
      t11 = isCopied ? <><Check className="w-4 h-4" />{!isMobile && "Copied!"}</> : <><Copy className="w-4 h-4" />{!isMobile && "Copy Address"}</>;
      $[4] = isCopied;
      $[5] = isMobile;
      $[6] = t11;
    } else {
      t11 = $[6];
    }
    let t12;
    if ($[7] !== t10 || $[8] !== t11 || $[9] !== t9) {
      t12 = <Button size="sm" color={t9} variant="flat" onPress={handleCopy} className="" isIconOnly={t10}>{t11}</Button>;
      $[7] = t10;
      $[8] = t11;
      $[9] = t9;
      $[10] = t12;
    } else {
      t12 = $[10];
    }
    let t13;
    if ($[11] !== t12 || $[12] !== t8) {
      t13 = <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mt-1">{t7}<Tooltip content={t8}>{t12}</Tooltip></div>;
      $[11] = t12;
      $[12] = t8;
      $[13] = t13;
    } else {
      t13 = $[13];
    }
    let t14;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <p className="text-xs text-foreground-400">Works on Dogechain, Shibarium, and any EVM chain</p>;
      $[14] = t14;
    } else {
      t14 = $[14];
    }
    let t15;
    if ($[15] !== t13) {
      t15 = <Col className="gap-3">{t5}{t6}{t13}{t14}</Col>;
      $[15] = t13;
      $[16] = t15;
    } else {
      t15 = $[16];
    }
    let t16;
    if ($[17] !== t15 || $[18] !== t4) {
      t16 = <div className={t4}>{t15}</div>;
      $[17] = t15;
      $[18] = t4;
      $[19] = t16;
    } else {
      t16 = $[19];
    }
    return t16;
  }
  const t4 = `p-6 bg-gradient-to-br from-warning/5 via-content1 to-danger/5 border border-warning/20 rounded-2xl ${className}`;
  let t5;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="p-3 rounded-xl bg-warning/20 flex-shrink-0"><Heart className="w-8 h-8 text-warning fill-warning" /></div>;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h3 className="text-lg font-bold">Support the Rescue Mission</h3>;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div>{t6}<p className="text-sm text-foreground-500 mt-1">Recovered some funds? Help us keep helping the community and fighting back against rugs! Tips are not required but <span className="text-warning font-medium">very much appreciated!</span></p></div>;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="items-center gap-2 mb-2"><Wallet className="w-4 h-4 text-foreground-500" /><span className="text-xs text-foreground-500 font-medium uppercase tracking-wide">Tip Address (Dogechain + Shibarium + All EVM Chains)</span></Row>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <code className="flex-1 px-3 py-2 bg-content1 rounded-lg text-xs sm:text-sm break-all border border-divider">{TIP_ADDRESS}</code>;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const t10 = isCopied ? "Copied!" : "Click to copy";
  const t11 = isCopied ? "success" : "warning";
  const t12 = isCopied ? "flat" : "solid";
  const t13 = `font-semibold ${!isCopied ? "text-black" : ""}`;
  const t14 = isMobile ? true : false;
  let t15;
  if ($[25] !== isCopied || $[26] !== isMobile) {
    t15 = isCopied ? <><Check className="w-4 h-4" />{!isMobile && "Copied!"}</> : <><Copy className="w-4 h-4" />{!isMobile && "Copy Address"}</>;
    $[25] = isCopied;
    $[26] = isMobile;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
    t16 = <Button size="md" color={t11} variant={t12} onPress={handleCopy} className={t13} isIconOnly={t14}>{t15}</Button>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t16) {
    t17 = <Row className="items-start gap-4 flex-wrap">{t5}<Col className="flex-1 gap-3 min-w-[280px]">{t7}<div className="p-3 bg-content2/50 rounded-xl">{t8}<Row className="items-center gap-2 flex-wrap">{t9}<Tooltip content={t10}>{t16}</Tooltip></Row></div></Col></Row>;
    $[34] = t10;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t4) {
    t18 = <div className={t4}>{t17}</div>;
    $[37] = t17;
    $[38] = t4;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}